import { render, staticRenderFns } from "./BoxRank.vue?vue&type=template&id=289be80b&scoped=true"
import script from "./BoxRank.vue?vue&type=script&lang=js"
export * from "./BoxRank.vue?vue&type=script&lang=js"
import style0 from "./BoxRank.vue?vue&type=style&index=0&id=289be80b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289be80b",
  null
  
)

export default component.exports